import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';

function PriceField({ value, onChange, ...props }) {
  const [internalValue, setInternalValue] = useState(value || '');

  useEffect(() => {
    setInternalValue(value || '');
  }, [value]);

  const formatPrice = (input) => {
    // If the input contains a decimal point, parse it as a float.
    if (input.includes('.')) {
      const num = parseFloat(input);
      return isNaN(num) ? '' : num.toFixed(2);
    }
    
    // Otherwise, assume the digits represent a value in pence.
    let digits = input.replace(/\D/g, '');
    if (!digits) return '';
    
    if (digits.length <= 2) {
      return Number(digits).toFixed(2);
    } else {
      const pounds = digits.slice(0, -2);
      const pence = digits.slice(-2);
      return Number(pounds + '.' + pence).toFixed(2);
    }
  };
  

  const handleBlur = (e) => {
    const formatted = formatPrice(e.target.value);
    setInternalValue(formatted);
    if (onChange) onChange(formatted);
  };

  const handleChange = (e) => {
    let val = e.target.value;
    // Allow only digits and period.
    val = val.replace(/[^0-9.]/g, '');
    // If more than one period exists, keep only the first one.
    const parts = val.split('.');
    if (parts.length > 2) {
      val = parts.shift() + '.' + parts.join('');
    }
    setInternalValue(val);
  };
  

  return (
    <TextField
      {...props}
      value={internalValue}
      onChange={handleChange}
      onBlur={handleBlur}
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-9]*'
      }}
    />
  );
}

export default PriceField;
